export default class extends HTMLElement {
  connectedCallback () {
    this.openBtn = this.querySelector('[data-open-demo]')
    this.openBtn?.addEventListener('click', () => this.openDemo())
  }

  openDemo () {
    const src = this.dataset.src
    const target = document.getElementById(this.dataset.targetId || 'live_example')
    if (!target) return

    target.classList.remove('hidden')
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })

    if (!src) {
      const mountEl = target.querySelector('[data-live-example-mount]')
      if (mountEl) {
        mountEl.innerHTML = '<div class="p-8 text-warning">Sample document could not be prepared. Check server logs and try again.</div>'
      }
      return
    }

    if (this._mounted) return
    this._mounted = true

    const mountEl = target.querySelector('[data-live-example-mount]')
    const scriptSrc = this.dataset.scriptSrc
    const existing = document.querySelector(`script[src="${scriptSrc}"]`)

    const mount = () => {
      const form = document.createElement('docuseal-form')
      form.id = 'docusealForm'
      form.setAttribute('data-src', src)
      mountEl?.replaceChildren(form)
    }

    if (existing || window.customElements.get('docuseal-form')) {
      mount()
      return
    }

    const script = document.createElement('script')
    script.src = scriptSrc
    script.onload = mount
    script.onerror = () => {
      if (mountEl) {
        mountEl.innerHTML = '<div class="p-8 text-error">Failed to load embed script.</div>'
      }
    }
    document.head.appendChild(script)
  }
}
